const messages = {
  titleColorRev: "true",
  buttons: {
    pending: "Na čekanju",
    open: "Otvori",
    requestAccess: "Zatraži pristup",
  },
  myBsApps: '<span class="text-danger">Moje aplikacije</span> Bridgestone',
  my: "Moje aplikacije",
  directRoute: "Vaše direktne veze ka Bridgestone web aplikacijama.",
  welcomeMessage:
    'Dobrodošli u BRIDGESTONE PLUS <span class="text-danger">PLUS</span>, %{first_name} %{last_name}',
  showProfile: "Prikaži profil",
  newMessages: "Nova poruka u primljenoj pošti",
  myApps: "Moje aplikacije",
  allApps: "Sve aplikacije",
  myAppsDescription: "Sve Bridgestone web aplikacije za koje ste registrirani.",
  allAppsDescription:
    "Sve Bridgestone web aplikacije koje bi vas mogle zanimati.",
  myProfile: {
    welcomeMessage:
      "Dobrodošli u vaš osobni prostor. Ovdje možete ažurirati ili prilagoditi vaše informacije i pregledati vašu primljenu poštu.",
    masterData: "Osnovni podaci",
    completeDetails:
      "Ispunite vaše osobne i podatke o tvrtki da osigurate ispravnu registraciju.",
    goToMasterData: "Idi na moje podatke",
    goToInbox: "Idi na primljenu poštu",
  },
  masterData: {
    welcomeMessage:
      "Dobrodošli u vaš osobni prostor. Ovdje možete ažurirati ili prilagoditi vaše osnovne podatke.",
    personalDetails: "Osobni podaci",
    companyDetails: "Podaci o tvrtki",
    emailAddress: "Email adresa",
    title: "Titula",
    surname: "Prezime",
    firstName: "Ime",
    jobPosition: "Radna pozicija",
    streetAndHouseNumber: "Adresa tvrtke",
    postalCode: "Poštanski broj",
    city: "Grad",
    country: "Zemlja",
    legalStructure: "Pravna struktura",
    customerNumber: "Bridgestone broj kupca",
    importantPleaseRead: "Važno, molimo pročitajte",
    customerNumberInfo:
      "Da biste ispravno dodijelili vaše narudžbe guma različitim trgovcima, važno je da navedete vaš broj kupca.",
    multipleCustomerNumbers:
      "Ako imate više brojeva kupaca kod trgovca, npr. za vašu glavnu tvrtku i podružnice, molimo prvo navedite broj kupca glavne tvrtke.",
    salesAssignment:
      "Prodaja povezana s dodatnim brojevima kupaca će biti dodijeljena vašoj glavnoj tvrtki.",
    supplier: "Dobavljač",
    addAnotherCustomerNumber: "Dodaj broj kupca",
    save: "Spremi",
    delete: "Obriši",
  },
  inbox: {
    welcomeMessage: "Ovdje možete pronaći obavijesti i važne vijesti.",
    sender: "Pošiljatelj",
    subject: "Predmet",
    date: "Datum",
    formConsulting: "Obrazac primljen - Hvala vam što ste ispunili vaš profil.",
    back: "Natrag",
  },
  legalAndContact: {
    cookieSettings: "Postavke kolačića",
    dataPolicy: "Politika podataka",
    termsOfUse: "Uvjeti korištenja",
    helpAndContact: "Pomoć i kontakt",
  },
  logInSignUp: {
    logIn: "Prijavi se",
    signUp: "Registriraj se",
    logInMessage: "Prijavite se s vašom email adresom i lozinkom.",
    signUpMessage: "Ako ste novi korisnik, molimo registrirajte se.",
  },
};

export default {
  messages,
};
